<template>
  <div class="d-flex flex-wrap justyfy-content-between">
    <h4 v-if="!items.length && !isFetching" class="m-3 font-16">
      {{ $resourceString["common.noResults"] }}
    </h4>
    <div v-for="hit in items" :key="`${hit.colorNumber}-${hit.styleNumber}`">
      <div
        class="result-wrapper"
        @mousedown.left.prevent.stop="$emit('onResultClick', hit)"
        @touchstart="$emit('onResultClick', hit)"
      >
        <div
          slot="item"
          class="result-img"
          :item="hit"
          :data-bg="updateBackgroundAttributes(hit)"
          :id="`${hit.colorNumber}-${hit.styleNumber}`"
          :style="[
            hit.backgroundSlideImage
              ? { backgroundImage: `url('${hit.backgroundSlideImage}')` }
              : { backgroundColor: hit.hexColor },
          ]"
          :data-inventoryType="hit.inventoryType"
        />
        <div class="info-overlay p-2">
          <template
            v-if="
              hit.inventoryType == 'Carpet' ||
                hit.inventoryType == 'Resilient'
            "
          >
            {{ hit.styleName }}<br>
            {{ hit.styleNumber }}<br>
            {{ hit.colorName }} {{ hit.colorNumber }}<br>
            <span class="text-capitalize">{{
              hit.inventorySubType.toLowerCase()
            }}</span>
          </template>
          <template v-if="hit.inventoryType.toUpperCase() == 'POM'">
            {{ $resourceString["virtualtray.pom"] }} {{ hit.colorNumber }}
          </template>
          <template v-if="hit.inventoryType == 'Paint'">
            {{ $resourceString["virtualtray.paint"] }} {{ hit.colorNumber }} {{ hit.colorName }}
          </template>
          <template
            v-if="
              hit.inventoryType == 'Inspiration' ||
                hit.inventoryType == 'Premix'
            "
          >
            {{ hit.colorName }}
          </template>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import Vue from "vue";
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters({
      items: "virtualTray/items",
      isFetching: "virtualTray/isFetching",
    }),
  },
  data() {
    return {};
  },
  methods: {
    updateBackgroundAttributes: function (hit) {
      if (hit.inventoryType == "Paint") this.setBenjaminMooreHex(hit);
      else {
        let urlTile = hit.imagePath
          ? hit.imagePath
          : this.$helpers.getItemBackgroundImage(hit, "tiles");

        let urlSlide = this.$helpers.getItemBackgroundImage(hit, "slides", urlTile);

        Vue.set(hit, "backgroundTileImage", urlTile);
        Vue.set(hit, "backgroundSlideImage", urlSlide);
      }
    },
    setBenjaminMooreHex: function (hit) {
      Vue.set(
        hit,
        "hexColor",
        hit.hex ? "#" + hit.hex : "black"
      );
    },
  },
};
</script>
